import Hook from "../utils/hook"

export default Hook(`ConfirmModal`, {
  targets: [`buttons`],
  actions: [
    {
      name: `confirmModalShow`,
      type: `confirm-modal:show`,
    },
  ],

  confirmModalShowAction() {
    window.setTimeout(() => {
      this.buttonsTarget?.firstElementChild?.focus()
    }, 0)
  },
})
